<template>
  <v-data-table
    light
    :headers="headers"
    :items="items"
    :items-per-page="itemsPerPage"
    :server-items-length="totalElements"
    @update:page="fetchData"
    @update:items-per-page="handleUpdatePageSize"
    @toggle-select-all="handleToggleSelectAll"
    @item-selected="handleItemSelected"
    class="elevation-1 common-table"
    :loading="loading"
    v-bind="$attrs"
    v-model="inValue"
  >
    <template v-slot:top>
      <div class="d-flex flex-wrap pa-2 mb-2 tool-bar">
        <slot name="search"></slot>
        <v-btn class="ma-2" color="primary" @click="fetchData(1)">查询</v-btn>
        <slot name="actions"></slot>
      </div>
    </template>

    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "CommonTable",
  model: {
    prop: "modelValue",
    event: "updateModelValue",
  },
  props: {
    getData: {
      type: Function,
      require: true,
    },
    headers: {
      type: Array,
      require: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      pageSize: 10,
      totalElements: 0,
    };
  },
  computed: {
    inValue: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("updateModelValue", newValue);
        return newValue;
      },
    },
  },
  created() {
    this.pageSize = this.itemsPerPage || this.pageSize;
    this.fetchData(1);
  },
  methods: {
    async fetchData(currentPage = 1) {
      this.loading = true;
      try {
        const { error, data } = await this.getData({
          currentPage,
          pageSize: this.pageSize,
        });

        if (error) return;

        this.items = data.content || [];
        this.totalElements = data.totalElements || 0;
      } finally {
        this.loading = false;
      }
    },
    handleUpdatePageSize(pageSize) {
      this.pageSize = pageSize === -1 ? this.totalElements : pageSize;
      this.fetchData();
    },
    async reset() {
      this.fetchData(1);
    },
    handleToggleSelectAll(data) {
      this.$emit("toggle-select-all", data);
    },
    handleItemSelected(data) {
      this.$emit("item-selected", data);
    },
  },
};
</script>

<style lang="scss">
.common-table {
  /* 偶数行的背景颜色 */
  &.v-data-table tbody tr:nth-child(even) {
    background-color: #f0f0f0;
  }

  /* 奇数行的背景颜色 */
  &.v-data-table tbody tr:nth-child(odd) {
    background-color: #ffffff;
  }
}
</style>
